export default __webpack_public_path__ + "static/media/rewind-button-dark.d0956be6.svg";